/**
 * Strips HTML tags from a string and returns plain text.
 * Uses a temporary DOM element to leverage the browser's HTML parsing.
 * @param html - The HTML string to clean
 * @returns Plain text content without HTML tags
 */
export function stripHtmlToPlainText(html: string): string {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.innerText || tempElement.textContent || '';
}
